export default {
  onboardingMobile: {
    welcomeModal: false,
    attendance: false,
    homework: false,
    singleHomework: false,
    grades: false,
  },
  onboardingDesktop: {
    welcomeModal: false,
    attendance: false,
    homework: false,
    singleHomework: false,
    grades: false,
  },
};
